import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Box from '@mui/material/Box';
import MenuElement from './MenuElement';
import { HomeButton } from './HomeButton';
import Paper from '@mui/material/Paper';
import AppsIcon from '@mui/icons-material/Apps';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import AttachMoneyTwoToneIcon from '@mui/icons-material/AttachMoneyTwoTone';
import { DealsPopup } from './DealsPopup';

const EvolvedMenu: React.FC = () => {
  const {
    allContentfulReviewPage: { nodes },
    allContentfulCalculatorPage,
  } = useStaticQuery(graphql`
    {
      allContentfulReviewPage {
        nodes {
          slug
          shortName
          contentful_id
          __typename
        }
      }
      allContentfulCalculatorPage {
        nodes {
          slug
          shortName
          contentful_id
          __typename
        }
      }
    }
  `);
  return (
    <Paper elevation={0} square>
      <Box
        display="flex"
        justifyContent="space-evenly"
        p="var(--small)"
        component="nav"
      >
        <HomeButton />
        <DealsPopup />
        {/* <MenuElement
          menuTitle={<AttachMoneyTwoToneIcon />}
          title="Tilbud og deals nå"
          nodes={allContentfulCalculatorPage.nodes}
        /> */}
        <MenuElement
          menuTitle={<MenuBookRoundedIcon />}
          id="simple-menu"
          title="Artikler"
          nodes={nodes}
        />
      </Box>
    </Paper>
  );
};

export default React.memo(EvolvedMenu);
